import { CSRF_TOKEN_URL } from '@/constant';

type CsrfTokenResponse = {
  csrf_token?: string;
};

export const CSRF_HEADER_NAME = 'X-CSRF-Token';

let csrfToken: string | null = null;
let inFlightRequest: Promise<string> | null = null;

const fetchCsrfToken = async (): Promise<string> => {
  const response = await fetch(CSRF_TOKEN_URL, {
    method: 'GET',
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch CSRF token: ${response.status}`);
  }

  const data: CsrfTokenResponse = await response.json();
  if (!data.csrf_token) {
    throw new Error('CSRF token response is missing csrf_token field');
  }

  return data.csrf_token;
};

/**
 * CSRFトークンを取得してセットする。
 * 同時に複数回呼ばれた場合、進行中のリクエストを共有する。
 */
const fetchInFlight = (): Promise<string> => {
  if (!inFlightRequest) {
    inFlightRequest = fetchCsrfToken()
      .then((token) => {
        csrfToken = token;
        return token;
      })
      .finally(() => {
        inFlightRequest = null;
      });
  }

  return inFlightRequest;
};

export const ensureCsrfToken = (): Promise<string> => {
  if (csrfToken) return Promise.resolve(csrfToken);
  return fetchInFlight();
};

export const refreshCsrfToken = (): Promise<string> => {
  csrfToken = null;
  return fetchInFlight();
};
